import BranchCollection from './BranchCollection';

export default BranchCollection;
